import React from 'react';
import NavBar from './components/NavBar';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import store from './redux/app/store';
import Home from './pages/Home';
import Blog from './pages/Blog';

export default function App() {
  return (
    <div>
      <BrowserRouter>
        <Provider store={store}>
          <NavBar />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/blogs/:blogID' element={<Blog />} />
          </Routes>
        </Provider>
      </BrowserRouter>
    </div>
  );
}
